class PickSubscription extends window.BAO.CustomElement() {
  initialize () {
    super.initialize()
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.DRAWER.OPEN,
      this.onDrawerOpen.bind(this),
    )
  }

  onDrawerOpen (e) {
    if (e.detail.key !== 'pick-subscription') return

    this.renderPickSubscription(this.productUrl)
  }

  onSelectChange (e) {
    this.renderPickSubscription(this.optionUrl(e))
  }

  renderPickSubscription (url) {
    if (!url) return

    window.BAO.sectionRenderer
      .fetch('pick-subscription', url)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res['pick-subscription'],
        )

        const myself = newDOM.querySelector(
          '[data-pick-subscription-external-el="container-inner"]',
        )

        this.externalEls.container.element.innerHTML = myself.outerHTML

        const coloursSelectEl = window.BAO.Utils.getElement(
          '[data-pick-subscription-el="colour"]',
        )

        const editionsSelectEl = window.BAO.Utils.getElement(
          '[data-pick-subscription-el="edition"]',
        )

        this.listeners.add(
          coloursSelectEl,
          'change',
          this.onSelectChange.bind(this),
        )
        this.listeners.add(
          editionsSelectEl,
          'change',
          this.onSelectChange.bind(this),
        )
      })
      .catch(() => {})
  }

  /**
   * @returns {URL}
   */
  get productUrl () {
    const handle = this.externalEls?.trigger?.element?.dataset?.handle
    const variant = this.externalEls?.trigger?.element?.dataset?.variant

    return `/products/${handle}${variant ? `?variant=${variant}` : ''}`
  }

  optionUrl (e) {
    const handle = e.target?.options[e.target.selectedIndex]?.dataset?.handle
    const variant = e.target?.options[e.target.selectedIndex]?.dataset?.variant

    return `/products/${handle}${variant ? `?variant=${variant}` : ''}`
  }
}

if (!customElements.get('pick-subscription')) {
  customElements.define('pick-subscription', PickSubscription)
}
